import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { NotificationsAction } from '@app/features/admin/settings/notifications/state/notifications.action';
import { SettingsServices } from '@app/features/admin/settings/state/settings.services';
import { SettingsState } from '@app/features/admin/settings/state/settings.state';
import { ProfileAction } from '@app/layout/common/profile/state/profile.action';
import { Preference, Profile } from '@app/layout/common/profile/state/profile.types';
import { AuthService } from 'app/core/auth/auth.service';
import { forkJoin, map, of, switchMap, take } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (_route, state) => {
  const router: Router = inject(Router);
  const authService = inject(AuthService);
  const settingService = inject(SettingsServices);
  const settingsState = inject(SettingsState);
  const accessToken = authService.accessToken;
  const profileAction = inject(ProfileAction);
  const notificationActions = inject(NotificationsAction);
  // const userActions = inject(UserActions);

  if (_route.queryParams?.from) {
    authService.storeKey('from', _route.queryParams?.from);
    authService.activePage('page', _route.queryParams?.page);
    if (!accessToken) {
      window.location.href = `https://dev-temporary-elsa.web.app/login/${ROUTE_NAMES.SHARE_COOKIE_REDIRECT}}`;
    } else {
      return of(true);
    }
  }

  // TODO: COMMENT OUT FOR RELEASE/1.0.10
  // const passkeyService = inject(PasskeyService);
  // passkeyService
  //   .checkPasskey()
  //   .pipe(take(1))
  //   .subscribe((response: { has_passkey: boolean }) => {
  //     localStorage.setItem('has_passkey', response?.has_passkey ? 'true' : 'false');
  //   });

  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        if (!authenticated) {
          const redirectURL = state.url === `/${ROUTE_NAMES.SIGN_OUT}` ? '' : `redirectURL=${state.url}`;
          const urlTree = router.parseUrl(`${ROUTE_NAMES.SIGN_IN}?${redirectURL}`);

          return of(urlTree);
        }

        profileAction.actions.get();
        // TODO: COMMENT OUT FOR CHEVRON
        // userActions.actions.getPreference();
        notificationActions.actions.getNotifications({
          params: null
        });
        return forkJoin({
          profileResult: profileAction.actions.getSuccess$.pipe(take(1))
          // preferenceResult: userActions.actions.getPreferenceSuccess$.pipe(take(1))
        }).pipe(
          switchMap(({ profileResult }: { profileResult: { profile: Profile }; preferenceResult: Preference }) => {
            return settingService.getUserPermissions(profileResult.profile.role_id).pipe(
              map((permissions) => {
                settingsState.set({
                  userPermissions: permissions
                });
                return true;
              })
            );
          })
        );
      })
    );
};
